import { CheckCircleOutlined } from '@ant-design/icons'

interface ProfileTagProps {
  tag: string
  isChecked?: boolean
}

export default function ProfileTag({ tag, isChecked }: ProfileTagProps): React.ReactElement {
  const cgClass = isChecked ? 'bg-green-lime text-black' : 'bg-purple-300/10 text-white border border-white/10'
  return (
    <div
      className={`${cgClass} text-xxs font-bold lg:font-extrabold px-4 py-2 rounded-full flex items-center h-7.5 gap-2 shadow-lg`}
    >
      {isChecked && <CheckCircleOutlined className="text-sm" />} {tag}
    </div>
  )
}
